/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { MultiSelect } from 'react-multi-select-component';
import { set, isEmpty, cloneDeep } from 'lodash';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import * as bomLibAction from '../../../Library/BomLibrary/store/BomLibrary.action';

import { createOptions, monthsPlaceholder, getYears, checkArray } from '../../../../Components/helper';

function ProductTypeForm({ suggestionEditMode, setEditedSupplierFactory, editedSupplierFactory, typeOptions }) {
  const { t } = useTranslation('common');

  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const { SystemMastersDetails, PomDetails, ColorLibraryDetails, BomLibraryDetails, Measuremets, UserDetails } = reducer;
  const { GradingList } = PomDetails;
  const { ColorWaysLibList } = ColorLibraryDetails;
  const { ReferenceSupplier, supplierFactories } = BomLibraryDetails;
  const { editedDevOrderData } = Measuremets;
  const { isSupLoggedIn, userInfo } = UserDetails;
  const {
    brandList,
    category1List,
    category2List,
    pcTypeList,
    productStatusList,
    lengthsList,
    productIdentifierList,
    pcpCustomAttribute,
  } = SystemMastersDetails;
  const [tags, setTags] = useState([]);
  const typeaheadConfig = useRef(null);
  const [state, setState] = useState({
    editedProductData: {},
    brandOptions: [],
    monthOptions: createOptions(monthsPlaceholder, 'name', '_id'),
    yearOptions: createOptions(getYears(), 'name', '_id'),
    category1Options: [],
    category2Options: [],
    gradingOption: [],
    allGrading: [],
    sizeOptions: [],
    lengthOptions: [],
    colourOptions: [],
    supplierOptions: [],
    isLoading: true,
    isImageUploadModalOpen: false,
    tagsOptions: [],
    isProductSizeUpdate: false,
    editRules: null,
    stateIsReorder: false,
    isUploadBtnDisable: false,
    isProductComponentModal: false,
    currentProductData: null,
    isDuplicate: false,
    descTags: false,
    defaultStatus: null,
    isGradingChange: false,
    requiredField: [
      {
        key: 'number',
        message: 'Product Number required.',
        isVisible: false,
      },
      {
        key: 'description',
        message: 'Product Description required.',
        isVisible: false,
      },
      {
        key: 'brandId',
        message: 'Brand selection required.',
        isVisible: false,
      },
      {
        key: 'catOneId',
        message: 'Category 1 selection required.',
        isVisible: false,
      },
      {
        key: 'catTwoId',
        message: 'Category 2 selection required.',
        isVisible: false,
      },
      {
        key: 'supplierType',
        message: 'Product Type is required.',
        isVisible: false,
      },
    ],
    handleAutoSelect: false,
    damConfirmModal: false,
    selectedBrandId: null,
    selectedProductType: null,
    selectedKeyChange: null,
    incrementCountList: '',
    bomConfirmmodal: false,
    activeProductIdentifierList: [],
    multiDynamicAttribute: [],
    showMultiAttributePopup: false,
    multiDynamicId: null,
    newMultiDropOptions: [],
  });
  const { editedProductData, isProductSizeUpdate, requiredField, defaultStatus, multiDynamicAttribute } = state;

  useEffect(() => {
    const init = async () => {
      try {
        const supplierIds = [userInfo?.userId];
        dispatch(bomLibAction.fetchSuppliersFactories(supplierIds));
      } catch (e) {
        console.error('Error occurred:', e);
      }
    };
    if (userInfo?.userId && isSupLoggedIn) {
      init();
    }
    setState((prevData) => ({
      ...prevData,
      editRules: null,
    }));
  }, [dispatch, userInfo?.userId, isSupLoggedIn]);

  const allGrading = useMemo(() => {
    if (checkArray(GradingList)) {
      return GradingList;
    }
    return [];
  }, [GradingList]);

  const supplierFactoriesOptions = useMemo(() => {
    if (Array.isArray(supplierFactories) && Array.isArray(editedProductData?.suppliers)) {
      const supplierIds = editedProductData?.suppliers?.map((sup) => sup._id) || [];
      const filteredSuppFactories = supplierFactories
        ?.filter((supplier) => supplierIds.includes(supplier.supplierId))
        ?.flatMap((supplier) => supplier.factories || []);

      return createOptions(filteredSuppFactories, 'factoryName', '_id');
    }
    return [];
  }, [editedProductData?.suppliers, supplierFactories]);
  useEffect(() => {
    if (Array.isArray(editedProductData?.selectedSupplierFactories)) {
      setEditedSupplierFactory((prev) => ({
        ...prev,
        selectedSupplierFactories: editedProductData.selectedSupplierFactories,
      }));
    }
  }, [editedProductData?.selectedSupplierFactories]);

  useEffect(() => {
    if (checkArray(productStatusList)) {
      const defaultStatusData = productStatusList?.find((ele) => ele?.isDefault === true);
      if (!isEmpty(defaultStatusData)) {
        setState((prevState) => ({
          ...prevState,
          editedProductData: { ...prevState?.editedProductData, status: editedProductData?.status || defaultStatus },
          defaultStatusData,
        }));
      }
    }
  }, [productStatusList]);

  useEffect(() => {
    if (!suggestionEditMode || (suggestionEditMode && editedProductData?.gradingGroups?.length === 0)) {
      setState((prevState) => ({
        ...prevState,
        brandOptions: brandList,
        category1Options: category1List,
        category2Options: category2List,
        lengthOptions: createOptions(lengthsList, 'name', '_id'),
        colourOptions: createOptions(ColorWaysLibList, 'refName', '_id'),
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        lengthOptions: createOptions(lengthsList, 'name', '_id'),
        colourOptions: createOptions(ColorWaysLibList, 'refName', '_id'),
      }));
    }
  }, [ColorWaysLibList, brandList, category1List, category2List, lengthsList, editedProductData?.gradingGroups?.length]);
  useEffect(() => {
    const callFun = async () => {
      setState((prevState) => ({
        ...prevState,
        multiDynamicAttribute: pcpCustomAttribute,
      }));

      if (state?.newMultiDropOptions?.length > 0 && state?.multiDynamicId) {
        const filterData = pcpCustomAttribute.filter((res) => res._id === state?.multiDynamicId);
        const filterNewValuesId = filterData?.[0]?.values?.filter((k) => state?.newMultiDropOptions.includes(k.keyName)).map((re) => re._id) || [];

        if (editedProductData?.multiCustomAttribute) {
          editedProductData?.multiCustomAttribute
            ?.filter((k) => k.colId === state?.multiDynamicId)
            ?.forEach((re) => {
              re.valId = [...new Set([...re.valId, ...filterNewValuesId])];
            });
        } else {
          editedProductData.multiCustomAttribute = [
            {
              colId: state?.multiDynamicId,
              valId: filterNewValuesId,
            },
          ];
        }

        setState((prevState) => ({
          ...prevState,
          newMultiDropOptions: [],
          multiDynamicId: null,
        }));
      }
    };
    if (Array.isArray(pcpCustomAttribute)) {
      callFun();
    }
  }, [pcpCustomAttribute]);

  useEffect(() => {
    const updateData = async () => {
      const copyState = cloneDeep(editedProductData);

      const allSizes = [];
      if (editedProductData?.gradingGroups?.length > 0) {
        editedProductData.gradingGroups.forEach((ele) => {
          if (ele?.sizeRanges?.length > 0) {
            ele.sizeRanges.forEach((size) => {
              const sizeObj = {
                label: size.name,
                value: size.name,
                isSampleSize: size.isSampleSize,
                groupName: ele.label,
              };
              allSizes.push(sizeObj);
            });
          }
        });
      }

      set(copyState, 'sizeOptions', allSizes);

      setState((prevData) => ({
        ...prevData,
        editedProductData: copyState,
        isProductSizeUpdate: false,
        isGradingChange: false,
        sizeOptions: allSizes,
      }));
    };
    if (isProductSizeUpdate) {
      updateData();
    }
  }, [isProductSizeUpdate]);

  useEffect(() => {
    if (checkArray(GradingList)) {
      const gradingGroups = GradingList?.map((ele) => {
        return {
          label: ele.name,
          value: ele._id,
          sizeRanges: ele.sizeRanges,
        };
      });
      setState((prevData) => ({
        ...prevData,
        allGrading: GradingList,
        gradingOption: gradingGroups,
      }));
    }
  }, [GradingList]);

  useEffect(() => {
    const setData = () => {
      const filterTags = editedDevOrderData?.tags?.filter((n) => n);
      if (checkArray(filterTags)) {
        const tagsData = createOptions(editedDevOrderData?.tags, 'name', 'id', true);
        setTags(tagsData);
      } else {
        setTags([]);
      }

      editedDevOrderData.originalColourLibraries = editedDevOrderData?.colourLibraries;
      editedDevOrderData.originalSuppliers = editedDevOrderData?.suppliers;
      if (editedDevOrderData?.year) {
        editedDevOrderData.year = parseInt(editedDevOrderData?.year);
      }
      if (isEmpty(editedDevOrderData?.status)) {
        editedDevOrderData.status = defaultStatus;
      }
      setState((prevState) => ({
        ...prevState,
        editedProductData: {
          ...editedDevOrderData,
          selectedSupplierFactories: editedDevOrderData?.supplierFactories,
        },
        descTags: editedDevOrderData?.tagDescription,
        stateIsReorder: editedDevOrderData?.isReorder ? editedDevOrderData.isReorder : false,
      }));
      updateGrading(allGrading, editedDevOrderData?.brandId, editedDevOrderData?.catOneId, editedDevOrderData?.catTwoId, false);
      if (editedDevOrderData?.gradingGroups) {
        setSizeOption(allGrading);
      }
    };
    if (editedDevOrderData) {
      setData();
    }
  }, [editedDevOrderData, allGrading]);
  useEffect(() => {
    if (pcTypeList?.length === 1) {
      setState((prevState) => ({
        ...prevState,
        editedProductData: { ...prevState.editedProductData, supplierType: pcTypeList[0] },
      }));
      const customattributeObject = { productType: pcTypeList[0]?._id };
      if (editedDevOrderData?.supplierType) {
        customattributeObject.isActive = true;
      }
      dispatch(systemMasterAction.getCustomAttributeFreeText(customattributeObject));
      setSupplierOption(pcTypeList[0]);
    }
  }, [pcTypeList, editedDevOrderData?.supplierType]);

  const handleSelect = (val, key) => {
    const copyState = cloneDeep(editedSupplierFactory);
    set(copyState, `${key}`, val);
    setEditedSupplierFactory(copyState);
  };

  const setSupplierOption = (selectVal) => {
    const supplierOption = ReferenceSupplier.filter(function (element) {
      return element.supplierType.includes(selectVal?._id);
    });

    setState((prevState) => ({
      ...prevState,
      supplierOptions: createOptions(supplierOption, 'name', '_id'),
    }));
  };

  const setSizeOption = (val) => {
    const newGradingSize = [];
    const sampleSizes = [];

    if (val?.length) {
      val.forEach((grad) => {
        if (grad?.sizeRanges?.length > 0) {
          grad.sizeRanges.forEach((size) => {
            const obj = {
              groupName: grad.name,
              isSampleSize: size.isSampleSize,
              label: size.name,
              value: size.name,
            };
            newGradingSize.push(obj);
            if (size.isSampleSize === true) {
              sampleSizes.push(size.name);
            }
          });
        }
      });
    }

    setState((prevState) => ({
      ...prevState,
      sizeOptions: newGradingSize,
      isProductSizeUpdate: true,
    }));

    return sampleSizes;
  };

  const handleInput = (text, key) => {
    const copyState = cloneDeep(editedProductData);
    set(copyState, `${key}`, text);
    requiredField?.forEach((e) => {
      if (e.key === key) {
        e.isVisible = false;
      }
    });
    if (key !== 'description') {
      if (typeaheadConfig.current) typeaheadConfig.current.clear();
    }
    setState((prevState) => ({
      ...prevState,
      editedProductData: copyState,
      requiredField,
    }));
  };

  const updateGrading = async (options, brandId, cat1Id, cat2Id, isDropdownChange) => {
    if (brandId && cat1Id && cat2Id && checkArray(options)) {
      const dataFilter = options.filter(function (element) {
        return element.brand.some(function (subElement) {
          return subElement._id === brandId;
        });
      });
      const dataFilter2 = dataFilter.filter((element) => element?.catsOneIds.includes(cat1Id) && element?.catsTwoIds.includes(cat2Id));
      const gradingGroups = dataFilter2.map((ele) => {
        return {
          label: ele.name,
          value: ele._id,
          sizeRanges: ele.sizeRanges,
        };
      });
      setState((prevState) => ({
        ...prevState,
        gradingOption: gradingGroups,
      }));
      if (isDropdownChange) {
        if (editedProductData?.gradingGroups?.length > 0) {
          const gradingExist = checkArray(dataFilter2)
            ? dataFilter2.filter((el) => {
                return editedProductData?.gradingGroups?.some((f) => {
                  return f.value === el._id;
                });
              })
            : [];
          if (gradingExist.length === 0) {
            setState((prevState) => ({
              ...prevState,
              sizeOptions: [],
            }));
            return false;
          }
          return setSizeOption(gradingExist);
        }
      }
    }
  };

  useEffect(() => {
    if (productIdentifierList?.length > 0) {
      const staticKeys = [];
      productIdentifierList?.forEach((item) => {
        if (item.name === 'Colourway' || item.name === 'Size' || item.name === 'Length') {
          staticKeys.push(item._id);
        }
      });

      setState((prevData) => ({
        ...prevData,
        keysToCheck: staticKeys,
        sizeKeyId: productIdentifierList.find((item) => item.name === 'Size')?._id,
        lengthKeyId: productIdentifierList.find((item) => item.name === 'Length')?._id,
        productNumberKeyId: productIdentifierList.find((item) => item.name === 'Product number')?._id,
        activeProductIdentifierList: productIdentifierList.filter((item) => item.isActive),
      }));
    }
  }, [productIdentifierList]);

  const hasError = (key) => {
    const checkError = requiredField.find((ele) => ele.key === key);

    if (checkError.isVisible) {
      return checkError.message;
    }
    return null;
  };

  return (
    <div>
      <div
        key={editedProductData.id || editedProductData._id || JSON.stringify(editedProductData)}
        className={
          editedProductData.status === 'Approved' || editedProductData.status === 'Deleted'
            ? 'disabled d-flex justify-content-between'
            : 'd-flex justify-content-between'
        }
      >
        <div className={editedProductData?.status === 'Approved' ? 'disabled suggestion-form mt-2' : 'suggestion-form  ml-4 mr-4'}>
          <Row>
            {editedProductData?.number && (
              <Col md="2">
                <div className={`common-input-control ${editedProductData?.number ? 'disabled' : ''}`}>
                  <p className="field-name">
                    {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_NUMBER')}
                    <span className="asterisk" style={{ color: 'red' }}>
                      *
                    </span>
                  </p>
                  <input
                    type="text"
                    placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_NUMBER_PLACEHOLDER')}
                    value={editedProductData?.number}
                    onChange={(e) => handleInput(e.target.value, 'number')}
                    className="form-control"
                    defaultValue={editedProductData?.productInformation?.number}
                  />
                </div>
              </Col>
            )}
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_DESCRIPTION')} <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.description}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.DESCRIPTION_PLACEHOLDER')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.BRAND')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.brandId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.BRAND')}
                />
                <span className="error-message d-block">{hasError('brandId')}</span>
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SUB_BRAND')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.subBrandId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SUB_BRAND')}
                />
                <span className="error-message d-block">{hasError('brandId')}</span>
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SEASON')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.seasonId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SEASON')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.MONTH')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.month}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.MONTH')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.YEAR')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.year}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.YEAR')}
                />
              </div>
            </Col>

            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGO0RY_1')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.catOneId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGO0RY_1')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORIES_2')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.catTwoId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORIES_2')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORIES_3')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.catThreeId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORIES_3')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORY4')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.catFourId?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORY4')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT_GRADING_GROUP')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.gradingGroups?.map((e) => e?.name) || []}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT_GRADING_GROUP')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SIZES')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.sizeRanges?.join(', ') || ''}
                  className="form-control pr-4"
                  placeholder="Select Size(s)"
                />
              </div>
            </Col>

            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.LENGTH')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.legLengths?.map((e) => e?.name)}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT_LENGTH')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.COLOUR_WAYS')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.colourLibraries?.map((e) => e.name)}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.COLOUR_WAYS')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">
                  {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_TYPE')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  maxLength={200}
                  className="form-control pr-4"
                  value={editedProductData?.supplierType?.name}
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_TYPE')}
                />
              </div>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('product-information:PRODUCT_MODAL.SUPPLIER_LABEL')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.suppliers?.filter((vl) => vl._id === userInfo?.userId)?.map((e) => e.supplierName) || ''}
                  className="form-control pr-4"
                  placeholder="Select Supplier(s)"
                />
              </div>
            </Col>
            <Col md="2">
              <div className="common-input-control">
                <p className="field-name">{t('product-information:PRODUCT_MODAL.FACTORY_LABEL')}</p>
                <MultiSelect
                  name="Factory"
                  options={supplierFactoriesOptions}
                  className="product-custom-multiselect common-new-multiselect w-100"
                  value={supplierFactoriesOptions?.filter(
                    (val) =>
                      Array.isArray(editedSupplierFactory?.selectedSupplierFactories) && editedSupplierFactory.selectedSupplierFactories.includes(val.value),
                  )}
                  labelledBy={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT_FACTORY')}
                  overrideStrings={{
                    selectSomeItems: t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT_FACTORY'),
                    search: t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SEARCH_FACTORIES'),
                  }}
                  onChange={(selected) => {
                    handleSelect(
                      selected.map((val) => val.value),
                      'selectedSupplierFactories',
                    );
                  }}
                />
              </div>
            </Col>
            <Col className="add-form" md={3} lg={2}>
              <FormGroup>
                <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                  <p className="field-name text-bold">
                    {t('BOM_TYPE_FORM.TRANSPORT')}
                    <span className="asterisk asterisk-req-green">*</span>
                  </p>
                  <input
                    type="text"
                    maxLength={200}
                    value={editedProductData?.transport}
                    className="form-control pr-4"
                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_TRANSPORT')}
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md="2">
              <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.STATUS')}</p>
                <input
                  type="text"
                  maxLength={200}
                  value={editedProductData?.status?.name}
                  className="form-control pr-4"
                  placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.STATUS')}
                />
              </div>
            </Col>
            {checkArray(editedProductData?.dynamicColumn) &&
              editedProductData.dynamicColumn
                .filter((ele) => ele?.isActive)
                .map((ele) => {
                  const isChoice = ele.type === 'dropdown' || ele.type === 'radio-button';
                  return (
                    <Col md="2" key={ele.colId}>
                      <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                        <p className="field-name">{ele.keyName}</p>
                        <input
                          type="text"
                          maxLength={200}
                          readOnly
                          value={(isChoice ? ele.valueName : ele.valueText) ?? ''}
                          className="form-control pr-4"
                          placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + ele.keyName}
                        />
                      </div>
                    </Col>
                  );
                })}

            {multiDynamicAttribute?.map((ele) => {
              const id = ele._id;
              if (ele.isActive && ele?.productType?.includes(editedProductData?.supplierType?._id)) {
                const filteredAttributes = editedProductData?.multiCustomAttribute?.filter((attribute) => attribute.colId === ele._id);
                const filteredValues = ele.values.filter((item) => filteredAttributes?.some((attribute) => attribute.valId.includes(item._id)));
                return (
                  <Col md="2" key={id}>
                    <div className={`common-input-control ${typeOptions?.value === 'amendment' ? 'disabled' : ''}`}>
                      <p className="field-name">{ele?.keyName}</p>
                      <input
                        type="text"
                        maxLength={200}
                        // value={selectedItem?.selectedOpt || null}
                        value={filteredValues.map((item) => ({
                          label: item.keyName,
                          value: item._id,
                        }))}
                        className="form-control pr-4"
                        placeholder={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.STATUS')}
                      />
                    </div>
                  </Col>
                );
              }

              return null;
            })}
          </Row>
        </div>
      </div>
    </div>
  );
}

export default ProductTypeForm;
